<template>
  <v-app>
    <v-container class="pa-6 ma-0 d-flex flex-column gap-6 align-center main-d">
      <!-- section 1 -->
      <v-container class="pa-0 ma-0">
        <ProductionFilter />
        <OverviewProduction 
          v-if="generationData"
          :generation-data="generationData"/>
      </v-container>
      <!--section 2 -->
      <v-container fluid class="pa-0 ma-0">
        <v-row dense>
          <!--real Production -->
          <v-col cols="12" md="6">
            <AreaRealProduction />
          </v-col>
          <!-- donate Production-->
          <v-col cols="12" md="6">
            <DonateProduction />
          </v-col>
        </v-row>
      </v-container>
      <!--section 3 -->
      <v-container class="pa-0 ma-0">
        <BarChart />
      </v-container>
    </v-container>
  </v-app>
</template>

<script>
import ProductionFilter from "./partial/ProductionFilter.vue";
import OverviewProduction from "./partial/OverviewProduction.vue";
import AreaRealProduction from "./partial/AreaRealProduction.vue";
import DonateProduction from "./partial/DonateProduction.vue";
import BarChart from "./partial/BarChart.vue";

export default {
  name: "generation",
  components: {
    ProductionFilter,
    OverviewProduction,
    AreaRealProduction,
    DonateProduction,
    BarChart,
  },
   data: () => ({
    generationData: null,
    // avgInvoiceData: null,
    loading: false,
  }),
  mounted() {
    this.getGenerationData();
    // this.getAvgData();
  },
  methods: {
    getGenerationData() {
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/invoice-kpi", {
          params: {
            dateType: "month",
          },
        })
        .then((response) => {
          let res = response.data;
          app.generationData = res.crmReport;
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
    // getAvgData() {
    //   var app = this;
    //   app.loading = true;
    //   this.$axios
    //     .get(this.$endpoint + "dashboard/charts/average-invoice-by-users", {
    //       params: {
    //         dateType: "month",
    //       },
    //     })
    //     .then((response) => {
    //       let res = response.data;
    //       app.avgInvoiceData = res.data;
    //     })
    //     .catch((err) => {
    //       app.loading = false;
    //     })
    //     .finally(() => {
    //       app.loading = false;
    //     });
    // },
  },
};
</script>

<style scoped>
.main-d {
  min-width: 400px !important;
}
</style>